import axios from 'axios';

// Use environment variable with fallback
const backendBaseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
console.log("🌐 Backend Base URL:", backendBaseURL);

const api = axios.create({
  baseURL: backendBaseURL,
  withCredentials: true
});

// Logging interceptors
api.interceptors.request.use(config => {
  console.log(`📤 API Request: ${config.method?.toUpperCase()} ${config.url}`);
  return config;
});

api.interceptors.response.use(
  response => {
    console.log(`✅ API Response from ${response.config.url}`, response.data);
    return response;
  },
  error => {
    console.error(`❌ API Error from ${error.config?.url}`, error);
    return Promise.reject(error);
  }
);

// Exported calls
export const fetchAuctionHouses = async () => {
  console.log("📡 Fetching auction houses...");
  return api.get('/auction-houses');
};

export const fetchAuctions = async () => {
  console.log("📡 Fetching auctions...");
  return api.get('/auctions');
};

export const fetchItems = async () => {
  console.log("📡 Fetching items...");
  return api.get('/items');
};

export default api;